import type { TablatureComment } from '@/types/tablatures'
import { Avatar, Rating } from '@ui/primitives'
import { Heading } from '@ui/primitives/Heading'
import { Text } from '@ui/primitives/Text'

interface TabCommentProps {
  comment: TablatureComment
  formatDateTime: (date: string) => string
}

export function TabComment({ comment, formatDateTime }: TabCommentProps) {
  return (
    <article className="border border-[var(--color-gray-200)] rounded-lg p-4 hover:bg-[var(--color-gray-50)] transition-colors">
      <div className="flex gap-4">
        <div className="flex-shrink-0">
          <Avatar
            src={comment.user.imageUrl}
            size="lg"
            alt={`Avatar de ${comment.user.displayName}`}
          />
        </div>

        <div className="flex-1 min-w-0">
          <header className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-3">
            <div>
              <Heading as="h4" size="sm">
                {comment.user.displayName}
              </Heading>
              <Text 
                size="sm" 
               
              >
                {formatDateTime(comment.createdAt)}
              </Text>
            </div>

            {comment.rating > 0 && (
              <div title={`Évaluation: ${comment.rating}/5`}>
                <Rating
                  value={comment.rating}
                  disabled={true}
                  cancel={false}
                  onChange={() => {}}
                />
              </div>
            )}
          </header>

          <div
            className="prose prose-sm max-w-none text-[var(--color-gray-800)]"
            dangerouslySetInnerHTML={{ __html: comment.message }}
          />
        </div>
      </div>
    </article>
  )
}
